import axios from 'axios'
import { API_URL } from '../../../../../../constants'
import { DISPUTE_REASON_API } from './consts'
import { DisputeReason } from './response.types'
import {
  CreateDisputeReasonRequest,
  ReorderRequest,
  UpdateDisputeReasonRequest,
} from './requests.types'

interface ApiResponse<T> {
  success: boolean
  data: T | null
  totalRows?: number
  errors?: Record<string, string>
  // Машиночитаемый код доменной ошибки (CPAYMENT-1591); на нём строятся тексты в модалке.
  errorCode?: string
}

export const getReasons = (params: { enabled?: boolean; page?: number; perPage?: number }) =>
  axios.get<ApiResponse<DisputeReason[]>>(`${API_URL}${DISPUTE_REASON_API}/list`, { params })

export const createReason = (body: CreateDisputeReasonRequest) =>
  axios.post<ApiResponse<DisputeReason>>(`${API_URL}${DISPUTE_REASON_API}`, body)

export const patchReason = (id: number, body: UpdateDisputeReasonRequest) =>
  axios.patch<ApiResponse<DisputeReason>>(`${API_URL}${DISPUTE_REASON_API}/${id}`, body)

export const reorderReasons = (ids: number[]) =>
  axios.patch<ApiResponse<DisputeReason[]>>(`${API_URL}${DISPUTE_REASON_API}/reorder`, {
    ids,
  } as ReorderRequest)
